var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/shop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3596 8.46971L22.0696 5.69971C21.6496 2.67971 20.2796 1.44971 17.3497 1.44971H14.9896H13.5097H10.4697H8.98965H6.58965C3.64965 1.44971 2.28965 2.67971 1.85965 5.72971L1.58965 8.47971C1.48965 9.54971 1.77965 10.5897 2.40965 11.3997C3.16965 12.3897 4.33965 12.9497 5.63965 12.9497C6.89965 12.9497 8.10965 12.3197 8.86965 11.3097C9.54965 12.3197 10.7097 12.9497 11.9997 12.9497C13.2896 12.9497 14.4197 12.3497 15.1096 11.3497C15.8797 12.3397 17.0696 12.9497 18.3096 12.9497C19.6396 12.9497 20.8396 12.3597 21.5896 11.3197C22.1896 10.5197 22.4597 9.50971 22.3596 8.46971Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3501 16.8595C10.0801 16.9895 9.12012 18.0695 9.12012 19.3495V22.0895C9.12012 22.3595 9.34012 22.5795 9.61012 22.5795H14.3801C14.6501 22.5795 14.8701 22.3595 14.8701 22.0895V19.6995C14.8801 17.6095 13.6501 16.6195 11.3501 16.8595Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3699 14.5998V17.5798C21.3699 20.3398 19.1299 22.5798 16.3699 22.5798C16.0999 22.5798 15.8799 22.3598 15.8799 22.0898V19.6998C15.8799 18.4198 15.4899 17.4198 14.7299 16.7398C14.0599 16.1298 13.1499 15.8298 12.0199 15.8298C11.7699 15.8298 11.5199 15.8398 11.2499 15.8698C9.46988 16.0498 8.11988 17.5498 8.11988 19.3498V22.0898C8.11988 22.3598 7.89988 22.5798 7.62988 22.5798C4.86988 22.5798 2.62988 20.3398 2.62988 17.5798V14.6198C2.62988 13.9198 3.31988 13.4498 3.96988 13.6798C4.23988 13.7698 4.50988 13.8398 4.78988 13.8798C4.90988 13.8998 5.03988 13.9198 5.15988 13.9198C5.31988 13.9398 5.47988 13.9498 5.63988 13.9498C6.79988 13.9498 7.93988 13.5198 8.83988 12.7798C9.69988 13.5198 10.8199 13.9498 11.9999 13.9498C13.1899 13.9498 14.2899 13.5398 15.1499 12.7998C16.0499 13.5298 17.1699 13.9498 18.3099 13.9498C18.4899 13.9498 18.6699 13.9398 18.8399 13.9198C18.9599 13.9098 19.0699 13.8998 19.1799 13.8798C19.4899 13.8398 19.7699 13.7498 20.0499 13.6598C20.6999 13.4398 21.3699 13.9198 21.3699 14.5998Z",
    fill: "#6C84F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.b5f477d23d9805dd9107f71e501ca7ce.svg";
export { ForwardRef as ReactComponent };